<template>
  <div class="row">
    <div class="col-md-12 mt-2">
      <ul class="activities">
        <li
          v-for="(item, index) in activities"
          :key="index"
        >
          <span v-html="item.text"/>
          <vs-tooltip
            :text="getDateTime(item.created_at)"
            position="left"
            class="info-icon"
          >
            <i
              class="fas fa-info-circle"
              style="font-size: 16px;"
            />
          </vs-tooltip>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activities: {
      type: Array,
      default: () => ([]),
    },
  },
}
</script>

<style scoped>
ul.activities {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
}
ul.activities li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
ul.activities li span {
  width: 80%;
  font-size: 11px;
}
ul.activities li i {
  color: #D4D4D4;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseSectionDocRefActivity.vue